import { Timesheet } from "../timesheet";
import { IConverter, TSnapshot } from "./generics";

export const timesheetConverter: IConverter<Timesheet> = {
  toFirestore(timesheet: Timesheet) {
    return timesheet;
  },
  fromFirestore(snapshot: TSnapshot): Timesheet {
    const data = snapshot.data();
    return {
      ...data,
      id: data?.id || "",
      userId: data?.userId || "",
      userEmail: data?.userEmail || "",
      userName: data?.userName || "",
      clientId: data?.clientId || "",
      projectId: data?.projectId || "",
      projectAssignmentId: data?.projectAssignmentId || null,
      description: data?.description || undefined,
      longDescription: data?.longDescription || undefined,
      date: data?.date || "",
      startTime: data?.startTime || "",
      endTime: data?.endTime || "",
      duration: data?.duration || 0,
      billable: data?.billable || false,
      submitted: data?.submitted || false,
      submittedAt: data?.submittedAt || "",
      approved: data?.approved || false,
      approvedAt: data?.approvedAt || null,
      approvedBy: data?.approvedBy || null,
      approvedByEmail: data?.approvedByEmail || null,
      rejected: data?.rejected || false,
      rejectedAt: data?.rejectedAt || null,
      rejectedBy: data?.rejectedBy || null,
        rejectedByEmail: data?.rejectedByEmail || null,
      timerActive: data?.timerActive || false,
      isAdmin: data?.isAdmin || false,
    };
  },
};


// id: string;
// userId: string;
// userEmail?: string;
// userName?: string;
// clientId: string;
// projectId: string;
// projectAssignmentId?: string | null;
// description?: string | undefined;
// longDescription?: string | undefined;
// date: string; // ISO string
// startTime: string; // ISO string
// endTime: string; // ISO string
// duration: number;
// billable: boolean;
// submitted: boolean;
// submittedAt?: string; // ISO string
// approved: boolean;
// approvedAt?: string | null; // ISO string
// approvedBy?: string | null;
// approvedByEmail?: string | null;
// rejected: boolean;
// rejectedAt?: string | null; // ISO string
// rejectedBy?: string | null;
// rejectedByEmail?: string | null;
// timerActive?: boolean;
// isAdmin?: boolean;